import React from 'react';

const Error = ({ error, onClose, onBackgroundClick }) => {
  return (
    <div className="App" onClick={onBackgroundClick}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        textAlign: 'center',
        maxWidth: '500px',
        margin: '0 auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px',
          fontSize: '30px',
          color: 'white'
        }}>
          ⚠️
        </div>
        <h2 style={{ color: '#333', marginBottom: '16px' }}>Configuration Error</h2>
        <p style={{ color: '#666', marginBottom: '24px', lineHeight: '1.5' }}>
          {error}
        </p>
        <button onClick={onClose} style={{
          padding: '12px 24px',
          backgroundColor: '#6c757d',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: '500'
        }}>
          Close Widget
        </button>
      </div>
    </div>
  );
};

export default Error;